import { Stack, Typography } from "@mui/material";
import { JSX } from "react";
import { CheckListItem } from "../../components/check-list/CheckListItem";
import { CheckListItemType } from "../../components/check-list/CheckListItemType";
import { DndCheckList } from "../../components/dnd-check-list/DndCheckList";
import { UICustomizationViewCategoryItem } from "./UICustomizationViewCategorySettings";

type UICustomizationViewSettingsProps = {
    category: UICustomizationViewCategoryItem;
    onItemClick: (item: CheckListItemType) => void;
    onItemMove: (oldIndex: number, newIndex: number) => void;
};

export default function UICustomizationViewSettings({
    category,
    onItemClick,
    onItemMove
}: UICustomizationViewSettingsProps): JSX.Element {
    return (
        <Stack
            direction="column"
            sx={{
                padding: 1,
                marginBottom: 1,
                border: theme => `1px solid ${theme.palette.divider}`,
                borderRadius: 4
            }}
        >
            {category.categoryLabel &&
                <Typography
                    variant="subtitle2"
                    sx={{
                        fontWeight: 700,
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        marginLeft: 1
                    }}
                >
                    {category.categoryLabel}
                </Typography>
            }
            {category.views?.length > 1
                ? <DndCheckList
                    items={category.views}
                    onItemClick={onItemClick}
                    onItemMove={onItemMove}
                />
                : <Stack direction="column" sx={{ maxHeight: 300, overflowY: 'auto' }}>
                    {category.views.map(item =>
                        <CheckListItem
                            id={item.key}
                            key={item.key}
                            displayText={item.displayText}
                            onClick={() => onItemClick({ ...item, checked: !item.checked })}
                            checked={item.checked}
                            active={item.active}
                            disabled={item.disabled}
                        />
                    )}
                </Stack>
            }
        </Stack>
    );
}